import { GeckoKestrelModel, KestrelInspectionType } from 'types'

export function getInspectionTypeLabelVisibility(
  inspectionType?: KestrelInspectionType
): boolean {
  if (inspectionType === KestrelInspectionType.ROOFTOP) {
    return true
  } else if (inspectionType === KestrelInspectionType.NAVY) {
    return false
  } else {
    // DEFAULT
    return true
  }
}

export function getInspectionTypeAreaVisibility(
  inspectionType?: KestrelInspectionType
): boolean {
  if (inspectionType === KestrelInspectionType.ROOFTOP) {
    return true
  } else if (inspectionType === KestrelInspectionType.NAVY) {
    return true
  } else {
    // DEFAULT
    return false
  }
}

export function getDataLayersVisibility(
  kestrelModel: GeckoKestrelModel | undefined
): boolean {
  if (!kestrelModel) {
    return false
  }

  if (kestrelModel.data.inspection_type === KestrelInspectionType.ROOFTOP) {
    return true
  } else if (
    kestrelModel.data.inspection_type === KestrelInspectionType.SITEVIEW &&
    kestrelModel?.data?.dataLayersConfig?.layers.length > 1
  ) {
    return true
  } else {
    return false
  }
}
